import { Anchor } from '@zillow/constellation-10';
import { token } from '@zillow/constellation';
import styled, { css } from 'styled-components';

export const ZillowNavbarMobileDropdownMenuSectionLinkAnchorHoverStylingMixin = css`
    color: ${token('colors.brand')} !important; // pfs styles compete with ours
`;

export type MobileDropdownMenuSectionLinkAnchorProps = {
    isExpanded: boolean;
};

export const MobileDropdownMenuSectionLinkAnchor = styled(Anchor)<MobileDropdownMenuSectionLinkAnchorProps>`
    font-family: ${token('fonts.sansSerif')};
    font-size: 15px;
    color: ${token('colors.textDark')};
    text-decoration: none;
    flex-grow: 1;
    text-align: center;
    &:hover {
        ${ZillowNavbarMobileDropdownMenuSectionLinkAnchorHoverStylingMixin};
    }
    &:visited {
        color: ${token('colors.textDark')} !important; // pfs styles compete with ours
    }
    &:visited:hover {
        ${ZillowNavbarMobileDropdownMenuSectionLinkAnchorHoverStylingMixin};
    }
    ${({ isExpanded }) =>
        isExpanded &&
        css`
            color: ${token('colors.brand')};
            font-weight: bold;
        `}
`;
